import { Link } from "react-router-dom";
import { useStores } from "../../stores";
import React, { useEffect, useMemo, useState } from "react";
import PopularProductItem from "../Products/PopularProductItem";
import { filter } from "lodash";

interface ILeftSidebarFilter {
  isMobileResolution: boolean;
}

const enableRatingsFilter = false;
const LeftSidebarFilter = ({ isMobileResolution }: ILeftSidebarFilter) => {
  const { shopStore } = useStores();
  const { departments, onSelectionDept, selected_dept, products } = shopStore;
  const [activeFilterSection, setActiveFilterSection] = useState("deps");

  useEffect(() => {
    if (selected_dept) setActiveFilterSection("deps");
  }, [selected_dept]);

  const popularProds = useMemo(() => {
    return filter(products, (o) => o.IsFrequentlyUsed === true).slice(0, 4);
  }, [products]);

  const handleFilterWidgetToggle = (e: any, title: string) => {
    e.preventDefault();
    setActiveFilterSection(activeFilterSection === title ? "" : title);
  };

  return (
    <>
      <div className="woocommerce-sidebar-area sticky-leftside-filter">
        {!isMobileResolution ? (
          <div className={`collapse-widget collections-list-widget open`}>
            <h3
              className={`collapse-widget-title ${
                activeFilterSection === "deps" ? "active" : ""
              }`}
              onClick={(e) => {
                handleFilterWidgetToggle(e, "deps");
              }}
            >
              <span id="lbl_lftfilt_category">Categories</span>
              <i className="fas fa-angle-up"></i>
            </h3>
            <ul
              className={`collections-list-row vh70 ${
                activeFilterSection === "deps" ? "block" : "none"
              }`}
            >
              <li key="all-1">
                <h6
                  className=""
                  onClick={() => (selected_dept ? onSelectionDept(null) : null)}
                >
                  <Link
                    to={""}
                    className={!selected_dept ? "btn btn-dark text-white" : ""}
                  >
                    ALL
                  </Link>
                </h6>
              </li>
              <li key="pplr-prod-2">
                <h6
                  className=""
                  onClick={() =>
                    selected_dept !== "pplr-prod"
                      ? onSelectionDept("pplr-prod")
                      : null
                  }
                >
                  <Link
                    to={""}
                    className={
                      selected_dept === "pplr-prod"
                        ? "btn btn-dark text-white"
                        : ""
                    }
                  >
                    Popular Products
                  </Link>
                </h6>
              </li>
              {departments?.map((item, idx) => {
                return (
                  <li key={item + idx}>
                    <h6
                      className=""
                      onClick={() =>
                        selected_dept !== item ? onSelectionDept(item) : null
                      }
                    >
                      <Link
                        to={""}
                        className={
                          selected_dept == item ? "btn btn-dark text-white" : ""
                        }
                      >
                        {item}
                      </Link>
                    </h6>
                  </li>
                );
              })}
            </ul>
          </div>
        ) : (
          <ul className="nav nav-pills d-flex flex-nowrap overflow-scroll mb-3">
            <li className="nav-item">
              <a
                href="#"
                className={`nav-link text-nowrap text-dark ${
                  !selected_dept ? "bg-dark active text-white" : null
                }`}
                onClick={() => (selected_dept ? onSelectionDept(null) : null)}
              >
                ALL
              </a>
            </li>
            <li className="nav-item">
              <a
                href="#"
                className={`nav-link text-nowrap text-dark ${
                  selected_dept === "pplr-prod"
                    ? "bg-dark active text-white"
                    : null
                }`}
                onClick={() =>
                  selected_dept !== "pplr-prod"
                    ? onSelectionDept("pplr-prod")
                    : null
                }
              >
                POPULAR PRODUCTS
              </a>
            </li>
            {departments?.map((item, idx) => {
              return (
                <li className="nav-item" key={item + idx}>
                  <a
                    className={`nav-link text-nowrap text-dark ${
                      selected_dept == item ? "bg-dark active text-white" : null
                    }`}
                    aria-current="page"
                    href="#"
                    onClick={() =>
                      selected_dept !== item ? onSelectionDept(item) : null
                    }
                  >
                    {item}
                  </a>
                </li>
              );
            })}
          </ul>
        )}

        {enableRatingsFilter ? (
          <div
            className={`collapse-widget collections-list-widget ${
              activeFilterSection != "ratings" ? "open" : ""
            }`}
          >
            <h3
              className={`collapse-widget-title ${
                activeFilterSection === "ratings" ? "active" : ""
              }`}
              onClick={(e) => {
                handleFilterWidgetToggle(e, "ratings");
              }}
            >
              <span id="lbl_lftfilt_rating">Rating</span>
              <i className="fas fa-angle-up"></i>
            </h3>
            <ul
              className={`price-list-row ${
                activeFilterSection === "ratings" ? "block" : "none"
              }`}
            >
              <li key={1}>
                <a href="/en/all-products/0/all-categories">
                  <div className="rating-side-bar">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                  </div>
                </a>
              </li>
              <li key={2}>
                <a href="/en/all-products/0/all-categories">
                  <div className="rating-side-bar">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="far fa-star"></i>
                  </div>
                </a>
              </li>
              <li key={3}>
                <a href="/en/all-products/0/all-categories">
                  <div className="rating-side-bar">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="far fa-star"></i>
                    <i className="far fa-star"></i>
                  </div>
                </a>
              </li>
              <li key={4}>
                <a href="/en/all-products/0/all-categories">
                  <div className="rating-side-bar">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="far fa-star"></i>
                    <i className="far fa-star"></i>
                    <i className="far fa-star"></i>
                  </div>
                </a>
              </li>
              <li key={5}>
                <a href="/en/all-products/0/all-categories">
                  <div className="rating-side-bar">
                    <i className="fas fa-star"></i>
                    <i className="far fa-star"></i>
                    <i className="far fa-star"></i>
                    <i className="far fa-star"></i>
                    <i className="far fa-star"></i>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        ) : null}

        {popularProds?.length ? (
          <div className="collapse-widget aside-products-widget">
            <h3 className="aside-widget-title" id="lbl_lftfilt_pop_prod">
              Popular Products
            </h3>
            {popularProds?.map((item, idx) => {
              return <PopularProductItem item={item} />;
            })}
          </div>
        ) : null}
      </div>
    </>
  );
};

export default LeftSidebarFilter;
